// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TEyxn","placeholdersHeader":"styles_placeholdersHeader__2CH12","editorStyle":"styles_editorStyle__22Yh_","placeholdersBox":"styles_placeholdersBox__3FknA"};